import { NextRouter, useRouter } from "next/router";
import { PotooSymbolLogotype } from "@ui-components/components/logo";
import { IconButton } from "@ui-components/components/Button/IconButton";
import { Button } from "@ui-components/components/Button/Button";
import { useLayoutEffect, useState } from "react";
import useDevice from "@/hooks/useDevice";
import { openProductPlan } from "@potoo-modules/functions/router";
import { useCustomToast } from "@ui-components/hooks/useToast";
import useDeviceWithUA from "@/hooks/useDeviceWithUA";
import useClickOutside from "@ui-components/hooks/useClickOutside";
import { useLanguageContext } from "@/contexts/language";
import { LanguageMap } from "@potoo-modules/constants";
import { LanguageCode } from "@/types/language";
//import { useEnvironment } from '@/hooks/useEnvironment';
import { TopBanner } from "@ui-components/components/TopBanner";
import { DeviceType } from "@/types/device.type";
import { useBannerVisibility } from "@/hooks/useBanner";
const enum NavKeys {
  SERVICE = "service",
  CREDIT = "credit",
  CUSTOMER = "customer",
  COMPANY = "company",
}

type NavItems = {
  key: string;
  path: string;
  text: string;
  target?: string;
};

const PcHeader = ({
  isKorean,
  navItems,
  trailButtonLabel,
  router,
  handleRouter,
  handleLanguageRouter,
  handleTrialButton,
  bannerTitle,
  radioLabel,
}: {
  isKorean: boolean;
  navItems: NavItems[];
  trailButtonLabel: string;
  router: NextRouter;
  handleRouter: (path: string, target?: string) => () => void;
  handleLanguageRouter: (language: LanguageCode) => void;
  handleTrialButton: () => void;
  bannerTitle: string;
  radioLabel: string;
}) => {
  const [showLanguageHandler, setShowLanguageHandler] = useState(false);
  const { language, setLanguage } = useLanguageContext();
  const languageControllerRef = useClickOutside(() => {
    setTimeout(() => {
      //global 버튼 클릭시 따닥 눌림 방지 위해 interval 추가
      setShowLanguageHandler(false);
    }, 100);
  });

  const handleLanguageController = () => {
    setShowLanguageHandler((prev) => !prev);
  };
  // const handleTrialButton = isKorean
  //   ? openProductPlan(!isPcDevice, showToast)
  //   : () => {
  //       window.ChannelIO("showMessenger");
  //     };
  const { showBanner, hideBanner, hideForWeek } = useBannerVisibility();


  return (
    <div>
      {showBanner && <TopBanner title={bannerTitle} deviceType="pc" radioLabel={radioLabel} onClose={hideBanner} onHideForWeek={hideForWeek}/>}
      <div className={`header-box ${showBanner ? 'with-banner' : ''}`}>
      <div className="pc">
        <div className="nav">
          <div className="logo">
            <PotooSymbolLogotype
              onClick={handleRouter(`/${language}`)}
              color="black"
              width={74}
              height={20}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="nav-list">
            {navItems.map(({ key, path, target, text }) => (
              <div
                className="nav-item body1-500 gray-950"
                onClick={handleRouter(path, target)}
                key={key}
              >
                {text}
              </div>
            ))}
          </div>
        </div>
        <div className="menu-list">
          <IconButton
            fontSize={20}
            className="gray-950"
            iconName="icon-icon-globe"
            onClick={handleLanguageController}
          />
          {showLanguageHandler && (
            <div
              className={`language-controller ${isKorean ? "" : "en"}`}
              ref={languageControllerRef}
            >
              <div
                className={`language-option ${isKorean ? "selected" : ""}`}
                onClick={() => {
                  handleLanguageRouter(LanguageMap.KOREAN);
                }}
              >
                 {isKorean ? "한국어" : "Korean"}
              </div>
              <div
                className={`language-option ${!isKorean ? "selected" : ""}`}
                onClick={() => {
                  handleLanguageRouter(LanguageMap.ENGLISH);
                }}
              >
                 {isKorean ? "영어" : "English"}
              </div>
            </div>
          )}
          <Button
            type="primary2"
            label={trailButtonLabel}
            icon="none"
            size="small"
            otherClassName="free-trial-button"
            onClick={handleTrialButton}
          />
        </div>
      </div>
    </div>
    </div>

  );
};

const MobileHeader = ({
  isKorean,
  navItems,
  trailButtonLabel,
  router,
  handleRouter,
  handleLanguageRouter,
  handleTrialButton,
  bannerTitle,

}: {
  isKorean: boolean;
  navItems: NavItems[];
  trailButtonLabel: string;
  router: NextRouter;
  handleRouter: (path: string, target?: string) => () => void;
  handleLanguageRouter: (language: LanguageCode) => void;
  handleTrialButton: () => void;
  bannerTitle: string;

}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentPath, setCurrentPath] = useState(NavKeys.SERVICE);

  const next = (path: string, target?: string) => () => {
    handleRouter(path, target)();
    setShowDropdown(false);
  };
  const handleMenu = () => {
    setShowDropdown((prev) => !prev);
  };

  useLayoutEffect(() => {
    const path = (router.asPath === "/" ? NavKeys.SERVICE : router.asPath) as NavKeys;
    setCurrentPath(path);
  }, [router.asPath]);

  const { showBanner, hideBanner, hideForWeek } = useBannerVisibility();

  return (
    <div>
      {showBanner && <TopBanner title={bannerTitle} deviceType="mobile" onClose={hideBanner} onHideForWeek={hideForWeek} />}
      <div className={`header-box mobile ${showBanner ? 'with-banner' : ''}`}>
        <div className="nav">
          <div className="logo">
          <PotooSymbolLogotype onClick={handleRouter("/")} color="black" width={74} height={20} />
        </div>
        <div className="touch-wrapper">
          <IconButton
            fontSize={20}
            className="gray-500"
            iconName={showDropdown ? "icon-icon-x" : "icon-icon-hamburger"}
            onClick={handleMenu}
          />
        </div>
      </div>
      {showDropdown && (
        <div className="nav-list">
          {navItems.map(({ key, path, target, text }) => (
            <div
              className={`nav-item gray-950 ${key === currentPath ? "selected" : ""}`}
              onClick={next(path, target)}
              key={key}
            >
              {text}
            </div>
          ))}
          <div className="language-controller">
            <div
              className={`language-option ${isKorean ? "selected" : ""}`}
              onClick={() => handleLanguageRouter(LanguageMap.KOREAN)}
            >
                 {isKorean ? "한국어" : "Korean"}
                 </div>
            <div className={`divider`}>|</div>
            <div
              className={`language-option ${!isKorean ? "selected" : ""}`}
              onClick={() => handleLanguageRouter(LanguageMap.ENGLISH)}
            >
              English
            </div>
          </div>
          {/* TODO: 가격 안내 활성화 시 아래 영역도 추가 */}
          <div className="nav-item free-trial-area">
            <Button
              type="primary2"
              label={trailButtonLabel}
              icon="none"
              size="small"
              otherClassName="free-trial-button"
              onClick={handleTrialButton}
            />
          </div>
        </div>
      )}
    </div>
    </div>

  );
};

const Header = () => {
  const router = useRouter();
  const { language } = router.query;
  const { isMobile, isPc } = useDevice();
  const {
    contents: { header, Banner },
    isKorean,
  } = useLanguageContext();

  const filterPlanWithoutKorean = (item: NavItems) => isKorean || item.key !== NavKeys.CREDIT;

  const navItems: NavItems[] = [
    {
      key: NavKeys.SERVICE,
      path: `/${language}`,
    },
    {
      key: NavKeys.CREDIT,
      path: `/${language}/credit`,
    },
    {
      key: NavKeys.CUSTOMER,
      path: `/${language}/customer`,
    },
    {
      key: NavKeys.COMPANY,
      path: header.aboutUsURL,
      target: "_blank",
    },
  ]
    .map((el, index) => ({
      ...el,
      text: header.navItems[index],
    }))
    //.filter(filterPlanWithoutKorean); // 요금제 개편 글로벌화로 인해 주석 처리 

  const handleRouter = (path: string, target?: string) => () => {
    //console.log("path", path);
    if (target) {
      //console.log("Opening in new window:", path);
      window.open(path);
    } else {
      //console.log("Pushing to router:", path);
      router.push(path);
    }
  };
  const handleLanguageRouter = (language: LanguageCode) => {
    const languagePattern = Object.values(LanguageMap).join("|");
    const regex = new RegExp(`\/(${languagePattern})(\/|$)`);
    const nextPath = router.asPath.replace(regex, `/${language}$2`);
    handleRouter(nextPath)();
  };
  const handleTrialButton = () => {
    // 영문인 경우, 한글인 경우 다르게 리다이렉트
    if (isKorean) {
      window.location.href = "https://app.potoo.ai/";
    } else {
      window.location.href = "https://app.potoo.ai/en/gallery";
    }

  };

  return (
    <>
      {isPc && (
          <PcHeader
            isKorean={isKorean}
            navItems={navItems}
            trailButtonLabel={header.trailButtonLabel}
            router={router}
          handleRouter={handleRouter}
          handleLanguageRouter={handleLanguageRouter}
          handleTrialButton={handleTrialButton}
          bannerTitle={Banner.pcTitle}
          radioLabel={Banner.radioLabel}
        />
      )}
      {!isPc && (
        <MobileHeader
          isKorean={isKorean}
          navItems={navItems}
          trailButtonLabel={header.trailButtonLabel}
          router={router}
          handleRouter={handleRouter}
          handleLanguageRouter={handleLanguageRouter}
          handleTrialButton={handleTrialButton}
          bannerTitle={Banner.mobileTitle}
         
        />
      )}
    </>
  );
};

export default Header;
